<script setup>
import {ref} from 'vue';
import {router} from '@inertiajs/vue3';
import {useForm} from '@inertiajs/vue3';
import JetButton from '@/Jetstream/Button.vue';
import JetFormSection from '@/Jetstream/FormSection.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetActionMessage from '@/Jetstream/ActionMessage.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
import JetSelect from "@/Jetstream/Select";
import JetCheckbox from "@/Jetstream/Checkbox";

const props = defineProps({
  user: Object,
});

const form = useForm({
  _method: 'PUT',
  workspace_id: props.user.id,
  internal_uid: props.user.internal_uid,
  name: props.user.name,
  company: props.user.company,
  email: props.user.email,
  phone: props.user.phone,
  is_active: props.user.is_active,
});

const updateProfileInformation = () => {
  form.post(route('customer.profile-info.update'), {
    errorBag: 'updateProfileInformation',
    preserveScroll: true,
  });
};
</script>

<template>
  <JetFormSection @submitted="updateProfileInformation">
    <template #title>
     {{ $t('Customer master data') }}
    </template>

    <template #description>
    </template>

    <template #form>
      <!-- Name -->
      <div class="col-span-6 sm:col-span-4">
        <JetLabel for="name" :value="$t('Name')"/>
        <JetInput
            id="name"
            v-model="form.name"
            type="text"
            class="mt-1 block w-full"
            autocomplete="name"
        />
        <JetInputError :message="form.errors.name" class="mt-2"/>
      </div>

      <!-- Email -->
      <div class="col-span-6 sm:col-span-4">
        <JetLabel for="email" :value="$t('Email')"/>
        <JetInput
            id="email"
            v-model="form.email"
            type="email"
            class="mt-1 block w-full"
        />
        <JetInputError :message="form.errors.email" class="mt-2"/>
      </div>

      <!-- Internal UID -->
      <div class="col-span-6 sm:col-span-4">
        <JetLabel for="internal_uid" :value="$t('Internal customer number')"/>
        <JetInput
            id="internal_uid"
            v-model="form.internal_uid"
            type="text"
            class="mt-1 block w-full"
            autocomplete="internal_uid"
        />
        <JetInputError :message="form.errors.internal_uid" class="mt-2"/>
      </div>

      <template v-if="user.is_consultant">
        <!-- Phone Number -->
        <div class="col-span-6 sm:col-span-4">
          <JetLabel for="phone" :value="$t('Phone number')"/>
          <JetInput
              id="phone"
              v-model="form.phone"
              type="text"
              class="mt-1 block w-full"
          />
          <JetInputError :message="form.errors.phone" class="mt-2"/>
        </div>

        <!-- Company -->
        <div class="col-span-6 sm:col-span-4">
          <JetLabel for="company" :value="$t('Company name')"/>
          <JetInput
              id="company"
              v-model="form.company"
              type="text"
              class="mt-1 block w-full"
              autocomplete="company"
          />
          <JetInputError :message="form.errors.company" class="mt-2"/>
        </div>

        <!-- departement
        <div class="col-span-6 sm:col-span-4">
          <JetLabel for="departement" value="Abteilung"/>
          <JetInput
              id="departement"
              v-model="form.departement"
              type="text"
              class="mt-1 block w-full"
              autocomplete="departement"
          />
          <JetInputError :message="form.errors.departement" class="mt-2"/>
        </div> -->
      </template>
      <div class="col-span-6 sm:col-span-4 pt-3">
        <label class="flex items-center">
          <jet-checkbox name="is_active" v-model:checked="form.is_active"/>
          <span
              class="ml-2 text-sm text-gray-600">{{ $t('Customer is active') }}</span>
        </label>
      </div>
    </template>

    <template #actions>
      <JetActionMessage :on="form.recentlySuccessful" class="mr-3">
        {{ $t('Saved.') }}
      </JetActionMessage>

      <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
        {{ $t('Save') }}
      </JetButton>
    </template>
  </JetFormSection>
</template>
